import React from 'react';
import { MessageCircle } from 'lucide-react';
import './WhatsAppFloat.css';

const WhatsAppFloat = () => {
  const whatsappNumber = '917796775959'; // Including country code (91 for India)
  const message = 'Hello! I would like to inquire about booking a room at Hotel The Container.';
  
  const handleWhatsAppClick = () => {
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="whatsapp-float" onClick={handleWhatsAppClick}>
      <div className="whatsapp-icon">
        <MessageCircle size={28} />
      </div>
      <div className="whatsapp-tooltip">
        <span>Chat with us on WhatsApp</span>
        <div className="phone-number">+91 77967 75959</div>
      </div>
    </div>
  );
};

export default WhatsAppFloat;
